<template>
<div class="container h-100">
    <div class="menutop_mobile">
     <div  @click="showprofile = !showprofile" class="circlehamburger" >
        <i style="color:white;" class="fas fa-bars"></i>
    </div>
        
    </div>
    <div class="columns h-100 is-marginless  fixhidden">
            <div  class="is-flex is-align-center is-justify-center column is-4 box-step pd-5 bgcolor h-100" :class="{openprofile: showprofile}" >
                <div class="">
                    <div class="has-text-left is-flex">
                        <div>
                            <div class="imgprofile">
                                <img v-if="forms.input.profileLogoMentor.name" :src="imgPath + forms.input.profileLogoMentor.name">
                                <img v-else src="@/assets/user.png">
                            </div>
                        </div>
                        <div class="textprofile" style="margin-bottom:20px">
                            <p class="fontnormal">
                            {{forms.input.nameMentor}} <span style="color:white">({{ forms.input.nicknameMentor }})</span>
                            </p>
                            <p class="fontnormal">
                            <span style="color:white"> {{ livingInMentor }}   </span> 
                            </p>
                            <p class="fontnormal">
                            <span style="color:white"> {{ forms.input.telephoneNumberMentor}} </span> 
                            </p>
                             <nav class="level is-mobile" style="margin-top:6px;">
                                <div class="level-left" style="display:block;width:100%;">
                                    <a title="facebook" v-if="forms.input.facebookMentor"  target="_blank" :href="'https://'+forms.input.facebookMentor" class="level-item">
                                        <div class="circle">
                                        <i class="fab fa-facebook-f"></i>
                                        </div>
                                    </a>
                                    <a title="linkedin" v-if="forms.input.linkedinMentor"  target="_blank" :href="'https://'+forms.input.linkedinMentor"  class="level-item">
                                        <div class="circle">
                                        <i class="fab fa-linkedin-in"></i>
                                        </div>
                                    </a>
                                    <a title="line" v-if="forms.input.lineMentor"  target="_blank" :href="'https://'+forms.input.lineMentor" class="level-item">
                                        <div class="circle">
                                        <i class="fab fa-line"></i>
                                        </div>
                                    </a>
                                     <a title="skype" v-if="forms.input.skypeMentor"  target="_blank" :href="'https://'+forms.input.skypeMentor" class="level-item">
                                        <div class="circle">
                                       <i class="fab fa-skype"></i>
                                        </div>
                                    </a>
                                    <a title="hangout" v-if="forms.input.hangoutsMentor"  target="_blank" :href="'https://'+forms.input.hangoutsMentor"  class="level-item">
                                        <div class="circle" style="color: #0d6aca; font-weight: bold;">
                                          H
                                        </div>
                                    </a>
                                    <a title="zoom" v-if="forms.input.zoomMentor"  target="_blank" :href="'https://'+forms.input.zoomMentor" class="level-item">
                                        <div class="circle" style="color: #0d6aca; font-weight: bold;">
                                        Z
                                        </div>
                                    </a>
                                </div>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
            <div class="column" >
                <div class="columns h-100">
                    <div class="column is-10 mg-x-auto h-100 is-flex is-align-center is-justify-center" >
                        <div class="">
                            <header>
                                <p class="has-text-centered">
                                <i class="fas fa-check-circle"></i>
                                </p>
                            </header>
                            <div class="card-content has-text-centered">
                                <div class="content">
                                    <div style="color:#0D6ACA;font-size:30px;font-weight:bold">
                                        Thanks!
                                    </div>
                                    <div class="signsuccess" >
                                        Your sign up mentor profile is Successful.
                                    </div>
                                    <div style="color:#585858;">
                                        The system is checking your qualifications within 3 days.
                                    </div>
                                    <div>
                                        Will notify the result of consideration by email
                                    </div>
                                    <br class="mobile_space">
                                    <br class="mobile_space">
                                    <br >
                                    <div >
                                        Browse your mentor profile
                                    </div>
                                </div>
                                 <a class="mg-t-5" @click="gopath('/form/edit')" >BACK TO HOME </a>
                            </div> 
                        </div>
                       
                    </div>

                </div>

            </div>
    </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import {HTTP,HTTPDynamic} from "@/axios.js";

export default{
    data() {
        return {
            showprofile:false,
            imgPath:process.env.VUE_APP_IMG_PROFILE,
        }
    },
    computed: {
        forms(){
            return this.$store.state.beforedataform
        },
         ...mapState(["beforedataform","token","formId"]),
    
    },
    methods:{
         gopath(val){
             this.$router.push(val)
        },
    },
    created(){
        console.log('sadasd',process.env.VUE_APP_IMG_PROFILE)
    }
}
</script>
<style scoped>
    .signsuccess{
        font-weight:bold;font-size: 30px;
    }
    .fa-check-circle{
        font-size: 82px
    }
    .fa-check-circle:before {
        content: "\f058";
    }
.level.is-mobile .level-item{
    float: left;
    margin-top: 4px;
    margin-right: 5px;
}
.blueoutline:hover,.blueoutline:focus,.blueoutline{
   border-radius: 21px !important;
    border-color: #0D6ACA !important;
    color: #0D6ACA !important;
    background: white !important;
    margin-top: 10px;
}
.fontblue .blueoutline:nth-child(n+1){
    margin-left: 10px;
}
.containeralldetail .fontnormal2:nth-child(n+1){
margin-top: 5px;
}
.underline{
  position: absolute;
  bottom: -15px;
  width: 100%;
  background: #F3F3F3;
  height: 1px;
}

.fontnormal2{
    position: relative;
    color: #000000 !important;
    font-size: 20px !important ;
    font-weight: normal;
    text-align: left;
}
.fontnormal2 .fontblue{
     position: relative;
    color: #0D6ACA !important;
    font-size: 20px !important ;
    font-weight: normal;
    text-align: left;
    margin-left: 5px;
    
}
.edit{
    cursor: pointer;
    float:right
}
.edit i{
color:#C4C4C4
}
.edit .fontnormal2{
    position: relative;
    color:#C4C4C4 !important;
    font-size: 20px !important ;
    font-weight: normal;
    text-align: left;
}
.buttonorange{
     padding: 5px 2rem;
    font-weight: 600;
    background: linear-gradient(180deg, #FD7900 -34.44%, #FFCB2A 133.33%);
    border-radius: 40px;
    margin: 0 auto;
    display: block;
}
.level.is-mobile{
    margin-top: 10px;
}
.level-item{
    margin-right: 0.55rem;
}
i{
  color: #0d6aca; 
}
.circle{
        border-radius: 50%;
    background: white;
    text-align: center;
    width: 30px;
    font-size: 13px;
    height: 28px;
    display: flex;
    position: relative;
        justify-content: center;
    align-items: center;
}

.fontnormal{
  font-family: 'Raleway';
font-size: 14px;
color: #FFFFFF;
}

.bgcolor{

    border-color: white !important;
    background-image: linear-gradient(#0d6aca, #0fb7f3);

}
.fontbold{
 font-family: 'Raleway';
  font-weight: bold;
font-size: 14px;
color: white;
}
.textprofile{
    min-height: 140px;
    padding: 20px 10px 10px 20px;
}
.title{
        color: white;
    padding-left: 11px;
    font-weight: bold;
     margin-bottom: 1.5rem;
}
.imgprofile{
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    width: 140px;
    height: 140px;
    border-radius: 70px;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
}

.imgprofile img{
    max-width: 100%;
}

.bgcolor{
    overflow:hidden !important;border-color:white !important;
    background-image: linear-gradient(#0d6aca, #0fb7f3);
}
.buttonc{
        padding-left: 2rem;
    padding-right: 2rem;
  background: linear-gradient(180deg, #FD7900 -34.44%, #FFCB2A 133.33%);
  border-radius: 40px;
}


/* menu */
.widthmenu{
width: 289px; position: absolute; top: 50%; left: 50%; transform: translate(-50%,-50%);
}

.menutop_mobile{
    height: 0;
}
.circlehamburger{
    display: none;
    height: 50px;
    width: 50px;
    position: fixed;
    background: #0d6aca;
    color: white;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    top: 5px;
    right: 5px;
    transition: all 0.5s;
    z-index: 100;
}



@media only screen and (max-width: 951px) {
    .card{
        width: 78%;
    box-shadow: none;
    min-width: 630px;
    margin: 0 auto;
    position: relative;
    top: 0;
    left: 0;
    transform: inherit;
    margin-top: 40px;
    }
    .widthmenu{
    width:90%;float:right;
    }

    .column.is-four-fifths{
        margin-top: 75px;
    padding: 22px;
    }
    div.column.is-one-quarter.box-step.pd-5.bgcolor{
    min-height: 200px;
    min-width: 390px;
    position: absolute;
    right: 2px;
    z-index: 88;
    border-radius: 20px;
    transform: scaleX(0);
      top: -300px;
    transition: all 0.5s;
    opacity: 0;
}
       .menutop_mobile .fontbold2{
    display: block
	}
 .circlehamburger{
    display: flex;
}
.menutop_mobile{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 4rem;
    background: #0d6aca;
    z-index: 99;
    transition: all 0.5s;
}

.openprofile{
    top: 70px !important;
    opacity: 1 !important;
    transform: scaleX(1)!important;
}
}
@media only screen and (max-width: 653px) {
    .card{
        min-width: inherit
    }
    .mobile_space{
        display:none
    }
}
@media only screen and (max-width: 610px) {
    .card-content{
        padding: 0;
    }
}
@media only screen and (max-width: 457px) {
    .signsuccess{
        font-size: 20px;
    }
}

@media only screen and (max-height: 627px) {
    .card{
        line-height: 1.5;
    }
}
/* .signsuccess */
@media only screen and (max-width: 400px) {
    div.column.is-one-quarter.box-step.pd-5.bgcolor{
       width: 316px;
    min-width: 315px;
    }
    .widthmenu{
    width: 100%;
    }
}
</style>
